import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import _ from "i18n";
import SubMenuLinkUA from "./SubMenuLinkUA";
import { SVG_ICONS } from "../../config/Common";

@connect((store) => {
  return {
    currentClient: store.auth.currentClient,
  };
})
export default class SubMenuUA extends Component {
  constructor(props) {
    super(props);
    this.state = { hovered: null };
  }

  render() {
    const { handleSetCurrentPage, currentPage, currentClient, plan } =
      this.props;
    const isPersonalized = plan === "PERSONALIZED";

    const menuItems = [
      {
        page: "LIST_PAGE",
        title: "list_campaigns",
        icon: "INBOX_LIGHT",
        visible: true,
      },
      {
        page: "PROGRAM_PAGE",
        title: "program_newsletters",
        icon: "CALENDAR_NEWSLETTER",
        visible: isPersonalized,
      },
      {
        page: "APPROVAL_PAGE",
        title: "approval",
        icon: "APPROVAL",
        visible: currentClient?.id === 4 || isPersonalized,
      },
      {
        page: "MODELS_PAGE",
        title: "models",
        icon: "TEMPLATES_LIGHT",
        visible: isPersonalized,
      },
      {
        key: "EMAILS_ADMIN",
        title: "Emails & Administration",
        icon: "GENERIC_EMAIL_LIGHT",
        visible: isPersonalized,
        children: [
          {
            page: "GENERIC_EMAILING",
            title: "Generic emails",
            icon: "GENERIC_EMAIL_LIGHT",
          },
          { page: "ADMINISTRATION", title: "administration", icon: "SETTING" },
        ],
      },
      {
        page: "USERS_PAGE",
        title: "users",
        icon: "DIRECTORY_LIGHT",
        visible: isPersonalized,
      },
      {
        page: "SETTINGS_PAGE",
        title: "settings",
        icon: "SETTING_LIGHT",
        visible: isPersonalized,
      },
    ];

    return (
      <ul className="menu">
        {menuItems
          .filter((item) => item.visible)
          .map((item) => {
            if (!item.children) {
              return (
                <SubMenuLinkUA
                  key={item.page}
                  currentPage={item.page}
                  title={_(item.title)}
                  icon={item.icon}
                  isActive={currentPage === item.page}
                  handleSetCurrentPage={handleSetCurrentPage}
                />
              );
            }

            const groupId = item.key;
            const isActive = item.children.some(
              (child) => child.page === currentPage,
            );
            return (
              <li
                key={groupId}
                className="sub-menu-ua__dropdown"
                onMouseEnter={() => this.setState({ hovered: groupId })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <a
                  className={`menu-ua__link ${isActive ? "active" : ""}`}
                  style={{ cursor: "pointer" }}
                >
                  <img src={"/img/icons/" + SVG_ICONS[item.icon]} />
                  <span className="title">{_(item.title)}</span>
                  <img
                    className="sub-menu-ua__chevron"
                    src="/img/icons/ChevronDown.svg"
                    alt=""
                  />
                </a>
                {this.state.hovered === groupId && (
                  <ul className="sub-menu-ua__dropdown-list">
                    {item.children.map((child) => (
                      <li key={child.page}>
                        <Link
                          to={"/newsletter-ua/BASIC"}
                          onClick={() => handleSetCurrentPage(child.page, null)}
                          className={`menu-ua__link ${
                            currentPage === child.page ? "active" : ""
                          }`}
                        >
                          <span
                            className="sub-menu-ua__dropdown-icon"
                            style={{
                              WebkitMaskImage: `url(/img/icons/${SVG_ICONS[child.icon]})`,
                              maskImage: `url(/img/icons/${SVG_ICONS[child.icon]})`,
                            }}
                          />
                          <span className="title">{_(child.title)}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
      </ul>
    );
  }
}
